module.exports = __webpack_public_path__ + "img/backgroundMobile.1a92516a.png";